import ApiService from '@/services/ApiService';
export default {
  listNotifications(input) {
    let baseUrl = '/notification'
    if(input) {
      const {page} = input
      if(page) {
        baseUrl += `?page=${page}`
      } else baseUrl += `?page=1`
    }
    return ApiService().get(baseUrl);
  },
  readNotify(id) {
    return ApiService().put(`/notification/read/${id}`);
  },
  deleteNotify(id) {
    return ApiService().delete(`/notification/${id}`);
  },
};
